import React from 'react';
import styled from 'styled-components';
import { Collapse } from 'antd';
import { COLOR } from 'constants/colors';
import { addRankSuffix } from '__utils/common-utils';
import { WarningIcon } from 'assets/icons/warning-icon';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';
import './index.css';
import { useEffect } from 'hoist-non-react-statics/node_modules/@types/react';

const StyledCollapse = styled(Collapse) <any>`
    &{
        padding: 16px;
        box-shadow: 0px 2px 4px #E0E0E0;
        margin: 16px 0;
        border-radius: 8px;
        border: ${(props: any) => props.borderVariant ? `1px solid ${props.borderVariant}` : `none`};
        background: ${(props: any) => props.orderStatus === 'VALID' ? 'white' : 'rgba(255, 255, 255, 1)'};
        .orderCardDetails{
            b.greenTxt, b.payPendingColor{
                color: ${(props: any) => props.orderStatus === 'VALID' ? '' : 'red'}; 
            }
        }
    }
    .ellipsis{
        font-size:14px;
        width: 64%;
    }
    .ant-collapse-content {
        font-size: 14px;
        color: ${(props: any) => props.orderStatus === 'VALID' ? 'black' : `${COLOR.GREY3}`};
    }
    .ant-collapse-item {
        border-bottom: unset; 
     }
    .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
        padding: 0;
    }
    .ant-collapse-item > .ant-collapse-header {
        padding: 0 0;
        color: ${(props: any) => props.orderStatus === 'VALID' ? 'black' : `${COLOR.GREY3}`};
        flex-wrap: wrap;
    }
`;

const LightText = styled.p`
    font-size: 14px;
    font-weight: 400;
    padding-left: 18px;
    margin-top: 8px;
    strong{   
        font-weight: 500;
    }
`;
const SiteCollapseCustom = styled.div`
    font-size: 14px;
    font-weight: 400;
`;

interface collapseProps {
    accordionItem: any;
    showAsAccordion?: boolean;
    borderVariant?: string;
    isPaymentLinkExpired?: boolean;
}

const ProductDetailCard: React.FC<collapseProps> = ({ accordionItem, showAsAccordion, borderVariant, isPaymentLinkExpired }: collapseProps) => {
    const { Panel } = Collapse;
    const isMobile = useMediaQuery({ maxWidth: 767 });    

    return (
        <StyledCollapse
            orderStatus={ showAsAccordion ? (isPaymentLinkExpired ? 'INVALID' : accordionItem?.orderStatus) : 'VALID' }
            bordered={ false }
            //@ts-ignore
            expandIcon={ ({ isActive }) => <></> }
            expandIconPosition="right"
            borderVariant={ borderVariant }
        >

            <Panel key={ accordionItem?.key }
                header={ showAsAccordion ?
                    <>
                        <div className='orderSummaryHeader'>
                            <p className= { isMobile ? "header ellipsis" : "header"} >
                                { accordionItem?.mutualFund?.schemeName ?? 'NA' }
                                <br /><small className='greyText'>{ accordionItem?.mutualFund?.subCategory ?? 'NA'}</small>
                            </p>
                            <strong>    &#8377; { accordionItem?.amount }</strong>
                        </div> 
                        <div className='orderCardDetails'>
                            <div>
                                <p className='greyText'>Remarks</p>
                                <b className={accordionItem?.investmentType.toLowerCase() === 'lumpsum' ? 'payPendingColor' :'greenTxt'}>{(accordionItem?.orderStatus == 'VALID' && accordionItem?.bseOrderNumber !== null) ? `${accordionItem?.investmentType.toLowerCase() === 'lumpsum' ? 'Pending Payment' : 'Active SIP'}` : 'Registration Error'}</b>
                            </div>
                            {(accordionItem?.investmentType.toLowerCase() !== 'lumpsum') && 
                            <>
                                <div>
                                    <p className='greyText'>SIP Installment Date</p>
                                    <p>{addRankSuffix(accordionItem?.sipDate)} of every month</p>
                                </div>
                                <div>
                                    <p className='greyText'>SIP Duration</p>
                                    <p>{accordionItem?.numOfInstallments} month(s)</p>
                                </div>
                            </>}
                            
                            <div>
                                <p className='greyText'>{(accordionItem?.investmentType.toLowerCase() === 'lumpsum') ? 'Lumpsum Order Date' : 'Order Placed'}</p>
                                <p>{moment(accordionItem?.createdDate).format('Do MMMM YYYY')}</p>
                            </div>
                            
                        </div>
                    </> :
                    <div style={ { display: 'grid', columnGap:'2px', gridTemplateColumns: 'auto auto' } }>
                        <WarningIcon /> { accordionItem }
                    </div> }
            >
            </Panel>
        </StyledCollapse>
    )
}

export default ProductDetailCard;